import axiosInstance from '@/api/axiosInstance';

const BASE = '/v1/streaks';

export interface LearningGoal {
  has_goal: boolean;
  weekday_target_minutes: number;
  weekend_target_minutes: number;
  current_streak: number;
  longest_streak: number;
  today_minutes: number;
}

export interface CalendarDay {
  date: string; // YYYY-MM-DD
  minutes: number;
  target_minutes: number;
  is_goal_day: boolean;
  goal_met: boolean;
  is_today: boolean;
  is_future: boolean;
}

export interface LearningCalendar {
  weekday_target_minutes: number;
  weekend_target_minutes: number;
  days: CalendarDay[];
}

export const LearningStreakApi = {
  /** Hot path — record active learning seconds (Redis only on the server). */
  heartbeat: (seconds: number): Promise<void> =>
    axiosInstance.post(`${BASE}/heartbeat`, { seconds }).then(() => undefined),

  getGoal: async (): Promise<LearningGoal> =>
    (await axiosInstance.get<LearningGoal>(`${BASE}/learning-goal`)).data,

  setGoal: async (
    weekday_target_minutes: number,
    weekend_target_minutes: number,
  ): Promise<LearningGoal> =>
    (
      await axiosInstance.put<LearningGoal>(`${BASE}/learning-goal`, {
        weekday_target_minutes,
        weekend_target_minutes,
      })
    ).data,

  getCalendar: async (start: string, end: string): Promise<LearningCalendar> =>
    (
      await axiosInstance.get<LearningCalendar>(`${BASE}/calendar`, {
        params: { start, end },
      })
    ).data,
};
